import React, { useState } from "react";
import "./customer.css";

export default function RequestDemoInfo() {
  const [requestDemoInfo] = useState([]);

  return (
    <div className="customerAnalytics">
      <h1>Request Demo Information</h1>
      <span>
        Total Request Demo Register :{" "}
        {requestDemoInfo ? requestDemoInfo.length : 0}
      </span>
      {requestDemoInfo && (
        <div style={{ overflowX: "scroll", width: "100%" }}>
          <table>
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email</th>
                <th>Phone No</th>
                <th>Company Name</th>
              </tr>
            </thead>
            <tbody>
              {requestDemoInfo.map((item, index) => (
                <tr key={index}>
                  <td>{item.fullName}</td>
                  <td>{item.email}</td>
                  <td>{item.phoneNumber}</td>
                  <td>{item.companyName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
